var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNewPayment = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20.5C4.47967 20.494 0.00606237 16.0204 0 10.5V10.3C0.109931 4.80455 4.63459 0.427974 10.1307 0.500898C15.6268 0.573822 20.0337 5.0689 19.9978 10.5654C19.9619 16.0618 15.4966 20.4989 10 20.5ZM10 2.50002C5.58172 2.50002 2 6.08174 2 10.5C2 14.9183 5.58172 18.5 10 18.5C14.4183 18.5 18 14.9183 18 10.5C17.995 6.0838 14.4162 2.50498 10 2.50002ZM10 15.5L8.59 14.09L11.17 11.5H5V9.50002H11.17L8.59 6.91002L10 5.50002L15 10.5L10 15.5Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNewPayment);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/new-payment.936daecbae78176c7cf63b351391b5da.svg";